import React from "react";
import { Bienvenidos } from "./styled";

export const Bienvenido = () => {
  return (
    <>
      <Bienvenidos>BIENVENIDO</Bienvenidos>
    </>
  );
};
